/**
 * Каталог прав из Delphi UMIUserLaw.pas.
 * id >= 0 — бит в LAW; id < 0 — группа (не пишется в LAW).
 */
export const RULES_COUNT = 200;

export const MI_USER_LAW = [
  { id: -1, idUpper: 0, name: "Администрирование", isGroup: true },
  { id: -2, idUpper: 0, name: "Документы", isGroup: true },
  { id: -3, idUpper: 0, name: "Карты", isGroup: true },
  { id: -4, idUpper: 0, name: "Клиенты", isGroup: true },
  { id: -7, idUpper: 0, name: "Справочники", isGroup: true },
  { id: -5, idUpper: 0, name: "Платежи", isGroup: true },
  { id: -6, idUpper: 0, name: "Путевки", isGroup: true },
  { id: -9, idUpper: 0, name: "Питание", isGroup: true },
  { id: -8, idUpper: 0, name: "Терминалы", isGroup: true },
  { id: -10, idUpper: 0, name: "Склад", isGroup: true },
  { id: -11, idUpper: 0, name: "СКД", isGroup: true },
  { id: -12, idUpper: 0, name: "Задачи", isGroup: true },

  { id: 0, idUpper: -1, name: "Редактирование пользователей", isGroup: false },
  { id: 40, idUpper: -1, name: "Настройки. Редактирование", isGroup: false },
  { id: 41, idUpper: -1, name: "Управление событиями", isGroup: false },
  { id: 67, idUpper: -1, name: "Просмотр действий пользователей", isGroup: false },
  { id: 81, idUpper: -1, name: "Отчеты", isGroup: false },
  { id: 94, idUpper: -1, name: "Настройка обмена с внешней системой", isGroup: false },
  { id: 101, idUpper: -1, name: "Журнал платежного терминала", isGroup: false },
  { id: 105, idUpper: -1, name: "Каналы продаж", isGroup: false },
  { id: 110, idUpper: -1, name: "Диалоги", isGroup: false },

  { id: 33, idUpper: -2, name: "Добавление", isGroup: false },
  { id: 34, idUpper: -2, name: "Удаление", isGroup: false },
  { id: 35, idUpper: -2, name: "Изменение", isGroup: false },
  { id: 108, idUpper: -2, name: "ЕГИСЗ", isGroup: false },
  { id: 109, idUpper: -2, name: "Исследования", isGroup: false },

  { id: 54, idUpper: -3, name: "Блокировка / разблокировка", isGroup: false },
  { id: 55, idUpper: -3, name: "Выдача", isGroup: false },

  { id: 3, idUpper: -4, name: "Доступ до всех клиентов", isGroup: false },
  { id: 9, idUpper: -4, name: "Редактирование состава истории болезни", isGroup: false },
  { id: 10, idUpper: -4, name: "Редактирование шаблонов назначений", isGroup: false },
  { id: 14, idUpper: -4, name: "Добавление", isGroup: false },
  { id: 15, idUpper: -4, name: "Удаление", isGroup: false },
  { id: 16, idUpper: -4, name: "Изменение", isGroup: false },
  { id: 59, idUpper: -4, name: "Изменение даты начала и окончания пребывания", isGroup: false },
  { id: 60, idUpper: -4, name: "Удаление оплат по депозиту", isGroup: false },
  { id: 17, idUpper: -4, name: "Планирование процедур", isGroup: false },
  { id: 18, idUpper: -4, name: "Назначение. Добавить", isGroup: false },
  { id: 19, idUpper: -4, name: "Назначение. Удалить", isGroup: false },
  { id: 20, idUpper: -4, name: "Назначение. Изменить", isGroup: false },
  { id: 21, idUpper: -4, name: "Назначение. Добавить из шаблона", isGroup: false },
  { id: 22, idUpper: -4, name: "Назначение. Копировать в шаблон", isGroup: false },
  { id: 87, idUpper: -4, name: "Назначение. Оплатить", isGroup: false },
  { id: 100, idUpper: -4, name: "Назначение. Редактировать цену", isGroup: false },
  { id: 23, idUpper: -4, name: "История болезни. Изменить", isGroup: false },
  { id: 24, idUpper: -4, name: "Дневник. Добавить", isGroup: false },
  { id: 25, idUpper: -4, name: "Дневник. Удалить", isGroup: false },
  { id: 26, idUpper: -4, name: "Дневник. Изменить", isGroup: false },
  { id: 107, idUpper: -4, name: "Дневник. Утвердить", isGroup: false },
  { id: 27, idUpper: -4, name: "Диагноз. Добавить", isGroup: false },
  { id: 28, idUpper: -4, name: "Диагноз. Удалить", isGroup: false },
  { id: 29, idUpper: -4, name: "Диагноз. Изменить", isGroup: false },
  { id: 91, idUpper: -4, name: "Удаление процедур из плана", isGroup: false },
  { id: 99, idUpper: -4, name: "Планировать неоплаченные платные услуги", isGroup: false },
  { id: 104, idUpper: -4, name: "Редактирование скидки", isGroup: false },
  { id: 106, idUpper: -4, name: "Автопланирование на даты вне периода пребывания", isGroup: false },

  { id: 13, idUpper: -5, name: "Просмотр журнала", isGroup: false },
  { id: 36, idUpper: -5, name: "Добавить", isGroup: false },
  { id: 37, idUpper: -5, name: "Удалить", isGroup: false },
  { id: 38, idUpper: -5, name: "Изменить", isGroup: false },
  { id: 47, idUpper: -5, name: "Работа с депозитами", isGroup: false },
  { id: 74, idUpper: -5, name: "Редактировать сумму вручную", isGroup: false },
  { id: 79, idUpper: -5, name: "Редактирование даты не фискального документа", isGroup: false },

  { id: 5, idUpper: -6, name: "Просмотр журнала", isGroup: false },
  { id: 11, idUpper: -6, name: "Бронирование", isGroup: false },
  { id: 30, idUpper: -6, name: "Добавить", isGroup: false },
  { id: 31, idUpper: -6, name: "Удалить", isGroup: false },
  { id: 32, idUpper: -6, name: "Изменить", isGroup: false },
  { id: 42, idUpper: -6, name: "Изменение чужих путевок", isGroup: false },
  { id: 45, idUpper: -6, name: "Изменение ежедневного варианта питания", isGroup: false },
  { id: 64, idUpper: -6, name: "Блокирование путевок", isGroup: false },
  { id: 65, idUpper: -6, name: "Отмена блокирования путевок", isGroup: false },
  { id: 66, idUpper: -6, name: "Групповое блокирования путевок", isGroup: false },
  { id: 68, idUpper: -6, name: "Ручной ввод номера версии при выписке ключа", isGroup: false },
  { id: 71, idUpper: -6, name: "Бронирование объектов", isGroup: false },
  { id: 72, idUpper: -6, name: "Ручное изменение цены услуги", isGroup: false },
  {
    id: 73,
    idUpper: -6,
    name: "Бронирование объектов. Изменение количества бронирования",
    isGroup: false
  },
  { id: 75, idUpper: -6, name: "Ручной ввод скидки", isGroup: false },
  { id: 76, idUpper: -6, name: "Подбор скидки", isGroup: false },
  { id: 77, idUpper: -6, name: "Ввод даты оплаты", isGroup: false },
  { id: 78, idUpper: -6, name: "Бронирование задним числом", isGroup: false },
  { id: 80, idUpper: -6, name: "Выселение из номера с долгом", isGroup: false },
  { id: 85, idUpper: -6, name: "Отмена заселения", isGroup: false },
  { id: 86, idUpper: -6, name: "Отмена выселения", isGroup: false },
  { id: 88, idUpper: -6, name: "Пополнение дисконтной карты по путевке", isGroup: false },
  { id: 92, idUpper: -6, name: "Просмотр всех филиалов", isGroup: false },
  { id: 93, idUpper: -6, name: "Возврат депозита по путевке без считывания карты", isGroup: false },

  { id: 1, idUpper: -7, name: "Товары / услуги. Просмотр", isGroup: false },
  { id: 2, idUpper: -7, name: "Клиенты. Просмотр", isGroup: false },
  { id: 4, idUpper: -7, name: "Настройка номеров", isGroup: false },
  { id: 6, idUpper: -7, name: "Изменение кабинетов", isGroup: false },
  { id: 7, idUpper: -7, name: "Изменение товаров/услу", isGroup: false },
  { id: 8, idUpper: -7, name: "Справочник кабинетов", isGroup: false },
  { id: 12, idUpper: -7, name: "Контрагенты", isGroup: false },
  { id: 39, idUpper: -7, name: "Праздники - редактирование", isGroup: false },
  { id: 43, idUpper: -7, name: "Статусы", isGroup: false },
  { id: 44, idUpper: -7, name: "Терминалы", isGroup: false },
  { id: 46, idUpper: -7, name: "Карты доступа", isGroup: false },
  { id: 48, idUpper: -7, name: "Кассы. Просмотр", isGroup: false },
  { id: 49, idUpper: -7, name: "Кассы. Редактирование", isGroup: false },
  { id: 50, idUpper: -7, name: "Кассы. X отчет", isGroup: false },
  { id: 51, idUpper: -7, name: "Кассы. Z отчет", isGroup: false },
  { id: 52, idUpper: -7, name: "Сертификаты. Просмотр", isGroup: false },
  { id: 53, idUpper: -7, name: "Сертификаты. Редактирование", isGroup: false },
  { id: 56, idUpper: -7, name: "Дисконтные карты. Просмотр", isGroup: false },
  { id: 57, idUpper: -7, name: "Дисконтные карты. Редактирование", isGroup: false },
  { id: 58, idUpper: -7, name: "Дисконтные карты. Пополнения", isGroup: false },
  { id: 69, idUpper: -7, name: "Объекты аренды. Просмотр", isGroup: false },
  { id: 70, idUpper: -7, name: "Объекты аренды. Редактирование", isGroup: false },
  { id: 98, idUpper: -7, name: "Служебные", isGroup: false },

  { id: 61, idUpper: -8, name: "Просмотр движений по карте", isGroup: false },
  { id: 62, idUpper: -8, name: "Возврат денег за услуги", isGroup: false },
  { id: 63, idUpper: -8, name: "Ручной ввод номера карты", isGroup: false },
  { id: 82, idUpper: -8, name: "Быстрые продажи", isGroup: false },
  { id: 89, idUpper: -8, name: "Быстрые продажи. Редактирование цены", isGroup: false },

  { id: 83, idUpper: -9, name: "Регистрация питания клиентов", isGroup: false },
  { id: 84, idUpper: -9, name: "Залы питания", isGroup: false },

  { id: 90, idUpper: -10, name: "Накладные", isGroup: false },

  { id: 95, idUpper: -11, name: "Настройка рабочих станций", isGroup: false },
  { id: 96, idUpper: -11, name: "Журнал движений", isGroup: false },
  { id: 97, idUpper: -11, name: "Оборудование Правила СКД", isGroup: false },

  { id: 102, idUpper: -12, name: "Сообщения", isGroup: false },
  { id: 103, idUpper: -12, name: "Шаблоны сообщений", isGroup: false }
];

/** Как Delphi: отсутствующий символ = разрешено (true). */
export function lawStringToFlags(law) {
  const flags = Array.from({ length: RULES_COUNT }, () => true);
  const s = String(law || "");
  for (let i = 0; i < RULES_COUNT; i += 1) {
    const ch = s[i];
    if (ch === "0") flags[i] = false;
    else if (ch === "1") flags[i] = true;
  }
  return flags;
}

export function flagsToLawString(flags) {
  const arr = Array.from({ length: RULES_COUNT }, (_, i) => (flags[i] === false ? "0" : "1"));
  return arr.join("");
}

export function allLawFlags(allowed) {
  return Array.from({ length: RULES_COUNT }, () => Boolean(allowed));
}
